import request from './request';

// 获取救济金活动配置
export const getReliefInfo = ({ activityId }: { activityId: string }) =>
  request({
    url: '/carbon-promotion/private/user/activity/relief/info',
    method: 'GET',
    params: { activityId }
  });

export const getReliefInfoWithoutAuth = ({ activityId }: { activityId: string }) =>
  request({
    url: '/carbon-promotion/public/activity/relief/info',
    method: 'GET',
    params: { activityId }
  });